module.exports = __webpack_public_path__ + "static/Harrison-429e94d8346bf8aa1d77d74d4c9ceb2d.jpeg";